/**
 * Optional If-None-Match for collab list REST under heavy load.
 * LiveKit is the realtime path; ETag skips unchanged list payloads.
 */

const etags = new Map<string, string>();

export function collabEtagKey(
  kind: "chat_public" | "chat_dm" | "qa" | "ann",
  sessionId: string,
  suffix = "",
): string {
  return suffix ? `${kind}:${sessionId}:${suffix}` : `${kind}:${sessionId}`;
}

export function getCollabEtag(key: string): string | undefined {
  return etags.get(key);
}

export function setCollabEtag(key: string, etag: string | undefined | null): void {
  if (!etag) return;
  etags.set(key, etag);
}

export function setCollabVersionAsEtag(
  kind: "chat_public" | "qa" | "ann",
  sessionId: string,
  version: number | undefined,
): void {
  if (version == null || Number.isNaN(Number(version))) return;
  setCollabEtag(
    collabEtagKey(kind, sessionId),
    `W/"${kind}-${sessionId}-${Number(version)}"`,
  );
}

export function clearCollabEtags(sessionId?: string): void {
  if (!sessionId) {
    etags.clear();
    return;
  }
  for (const key of Array.from(etags.keys())) {
    if (key.includes(`:${sessionId}`) || key.endsWith(`:${sessionId}`)) {
      etags.delete(key);
    }
  }
}
